<template>
  <section class="stats-section" ref="statsRef">
    <div class="stats-bg" aria-hidden="true"></div>
    <div class="section-container">
      <div class="stats-row">
        <template v-for="(item, i) in items" :key="i">
          <div class="stats-divider" v-if="i > 0"></div>
          <div class="stats-item">
            <div class="stats-num" :class="{ animated: visible }">{{ item.number }}</div>
            <div class="stats-label">{{ item.label }}</div>
          </div>
        </template>
      </div>
    </div>
  </section>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue';

const props = defineProps({
  config: { type: Object, default: () => ({}) },
});

const items = computed(() => (Array.isArray(props.config.items) && props.config.items.length
  ? props.config.items
  : [
    { number: '2000+', label: 'طالب مسجّل' },
    { number: '350+', label: 'درس مسجّل' },
    { number: '95%', label: 'نسبة النجاح' },
    { number: '4', label: 'صفوف دراسية' },
  ]));

const statsRef = ref(null);
const visible = ref(false);

onMounted(() => {
  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        visible.value = true;
        observer.disconnect();
      }
    });
  }, { threshold: 0.3 });

  if (statsRef.value) observer.observe(statsRef.value);
});
</script>

<style scoped>
*, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
.section-container { max-width:1200px;margin:0 auto;padding:0 2rem; }

.stats-section { padding:5rem 0;position:relative;overflow:hidden;background:linear-gradient(135deg,#0f0c29,#302b63); }
.stats-bg { position:absolute;inset:0;background:radial-gradient(ellipse at 50% 50%,rgba(5, 22, 41,.2) 0%,transparent 70%); }
.stats-row { display:flex;align-items:center;justify-content:center;gap:0;flex-wrap:wrap;position:relative;z-index:1; }
.stats-item { display:flex;flex-direction:column;align-items:center;gap:.4rem;padding:1.5rem 3rem;text-align:center; }
.stats-num { font-size:clamp(2rem,4vw,3rem);font-weight:900;color:#fff;opacity:0;transform:translateY(20px);transition:all .8s cubic-bezier(.4,0,.2,1);font-family:'Cairo',sans-serif; }
.stats-num.animated { opacity:1;transform:translateY(0); }
.stats-item:nth-child(3) .stats-num.animated { transition-delay:.1s; }
.stats-item:nth-child(5) .stats-num.animated { transition-delay:.2s; }
.stats-item:nth-child(7) .stats-num.animated { transition-delay:.3s; }
.stats-label { font-size:.9rem;color:rgba(255,255,255,.6);font-weight:500; }
.stats-divider { width:1px;height:60px;background:rgba(255,255,255,.1);align-self:center; }

@media(max-width:900px) { .stats-item { padding:1rem 1.5rem; } .stats-divider { height:40px; } }
@media(max-width:600px) { .stats-item { padding:.75rem 1rem; } .stats-divider { display:none; } .stats-row { gap:1rem; } }
</style>
